import * as React from 'react'

function SuccessIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={43} height={43} {...props}>
      <defs>
        <style>
          {
            '.prefix__a{fill:none;stroke:#00a9e3;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px}'
          }
        </style>
      </defs>
      <g transform="translate(-959 -1127)">
        <circle
          className="prefix__a"
          cx={20}
          cy={20}
          r={20}
          transform="translate(960.5 1128.5)"
        />
        <path className="prefix__a" d="M991.5 1140.5l-14 16M969.5 1149.5l8 7" />
      </g>
    </svg>
  )
}

export default SuccessIcon
